'use strict';
var ErrorStackParser = require('error-stack-parser');

module.exports = function (module) {
  /**
   * Override Angular's built in exception handler, and tell it to
   * use our new exceptionLoggingService which is defined below
   */
  module.provider('$exceptionHandler', {
    $get: ['ExceptionLogger', function (ExceptionLogger) {
      return ExceptionLogger;
    }]
  });

  /**
   * Exception Logging Service, currently only used by the $exceptionHandler
   * it preserves the default behaviour ( logging to the console) but
   * also posts the error server side after generating a stacktrace.
   */
  module.provider('ExceptionLogger', function ExceptionLoggerProvider() {
    var pr_fbURL = '';

    this.firebaseURL = function (fbURL) {
      if (typeof fbURL === 'undefined') {
        return pr_fbURL;
      }
      pr_fbURL = fbURL;
    };

    this.$get = [
      '$log',
      '$window',
      'APP_ENV',
      function ($log, $window, APP_ENV) {

        var loggerRef;

        //try {
        //  loggerRef = new $window.Firebase(pr_fbURL + '/logger/exceptions');
        //  //console.log('created loggerRef', loggerRef, $window.Firebase);
        //} catch (loggingError) {
        //  $log.warn('Error fetching Firebase: ' + pr_fbURL);
        //  $log.log(loggingError);
        //}

        function error(exception, cause) {
          // try to log the error to the server side.
          try {
            if (loggerRef) {
              var errorMessage = exception.toString();

              // use our traceService to generate a stack trace
              var stackTrace = ErrorStackParser.parse(exception);

              // use AJAX (in this example jQuery) and NOT
              // an angular service such as $http

              loggerRef.push({
                clientVersion: APP_ENV.CLIENT_VERSION,
                url: $window.location.href,
                message: errorMessage,
                type: 'exception',
                stackTrace: stackTrace,
                cause: ( cause || ''),
                dateCreated: new Date().getTime()
              });
            } else {
              $log.warn('Error server-side logging failed', cause);
              $log.log(exception);
            }
          } catch (loggingError) {
            $log.warn('Error server-side logging failed', cause);
            $log.log(loggingError);
          } finally {
            // preserve the default behaviour which will log the error
            // to the console, and allow the application to continue running.
            $log.error.apply($log, arguments);
          }
        }

        return error;
      }]
  });
};


// WEBPACK FOOTER //
// ./src/js/core-utilities/firebaseLogger/ExceptionHandler.js